import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
import Select from "react-select";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { URL_API } from "variable";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
toast.configure();

function CreateFormInfo() {
  const history = useHistory();
  const [optionText, setOptionText] = useState();
  const [selectType, setSelectype] = useState();
  const [formInfo, setFormInfo] = useState([]);
  const [enums, setEnums] = useState([]);



  useEffect(() => {
    getFormInfo();
    let token = localStorage.getItem("token");
  }, []);

  const onOptionTextChange = (e) => {
    setOptionText([e.target.value]);
  };

  const onSelectTypeChange = (selectType) => {
    setSelectype(selectType);
  };


  const getFormInfo = () => {
    axios.get(URL_API + "auth/admin/form-info").then((response) => {
      if (response.data.status === 200) {
        if (response.status == 200) {
          const options = [];
          obj = {};
          for (var i = 0; i < response.data.enums.length; i++) {
            var obj = {};
            obj["value"] = response.data.enums[i];
            obj["label"] = response.data.enums[i];
            options.push(obj);
          }
          setEnums(options);
        }
      }
    });
  };

  
  const onSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    formData.append("select_type", selectType?.value);
    formData.append("select_option", optionText);
    axios
      .post(URL_API + "auth/admin/form-info", formData)
      .then((response) => {
        if (response.data.status == 200) {
          history.push("/admin/form-info");
          toast.success("Select Option Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles?.HeroiImgBlogForm}>
              <div className={styles?.paddingTopBottomBlogForm}>
                <h3 className={styles?.HeroiImgTextBlogForm}>Add Option</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles?.blogPostForm}`}>
                <div className="form-group">
                  <FormGroup>
                    <Label for="City">Select Field</Label>
                    <Select
                      allowSelectAll={true}
                      value={selectType}
                      onChange={onSelectTypeChange}
                      options={enums}
                      isMulti={false}
                      required="required"
                    />
                  </FormGroup>
                </div>

                <div className="form-group">
                  <label htmlFor="post-title" className={styles?.labelPostForm}>
                    Option Text   
                  </label>
                    <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="value"
                    onChange={(e) => onOptionTextChange(e)}
                  />
                </div>

                <br />
                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles?.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default CreateFormInfo;
